import React from "react";
import {
  qhseBg,
  services31,
  services32,
  servicesPrez31,
} from "../../../../assets/images";
import { useTranslation } from "react-i18next";
import SubOtherHero from "../../../../Components/Breadcrumb/SubOtherHero/SubOtherHero";

const Resato = () => {
  const { t } = useTranslation();

  return (
    <>
      <div
        className="bg-black/60"
        style={{
          position: "relative",
          overflow: "hidden",
          backgroundImage: `url(${qhseBg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          width: "100%",
          height: window.innerWidth < 640 ? "200px" : "300px",
        }}
      >
        <SubOtherHero title="Resato high pressure technology" />
      </div>

      <div className="bg-[#EDEDED] py-10 md:py-20">
        <div className="max-w-containerSm md:max-w-container mx-auto md:flex md:items-start md:justify-between gap-10">
          {/* Left Content */}
          <div className="md:w-1/2">
            <p className="text-[22px] md:text-[44px] font-bold text-[#141615] font-firstFont">
              {t("Resato high pressure technology")}
            </p>

            <p className="mt-5 text-[14px] md:text-[20px] text-[#41444B]">
              {t(
                "Caspian Rock Solutions LLC, a proud member of the Caspian Rock Solutions group, is Official Distributor of Resato International B.V. in Azerbaijan since 2009."
              )}
            </p>
            <p className="mt-5 text-[14px] md:text-[20px] text-[#41444B]">
              {t(
                "Resato is one of the world’s leading manufacturers of High Pressure components and systems, with pressures up to 14.000 bar / 200,000 psi."
              )}
            </p>
            <p className="mt-5 text-[14px] md:text-[20px] text-[#41444B]">
              {t(
                "We supply Well head control, BOP control, Hydraulic test, Gas test, Chemical injection units.These units are excellent for testing completions, accumulators, cylinders, valves, bodies, vessels, piping. Suitable for various media such as: water, oil, oceanic oil, glycol, methanol. We supply separated components like gauge, recorder, transducer, fitting, adapter, tubing, hand/air operated valve, hydraulic pumps, gas boosters."
              )}
            </p>

            <a
              href={`${servicesPrez31}`}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block bg-[#B31F11] text-white py-2 px-4 rounded-md transition-colors mt-5"
            >
              {t("To learn more please download KTB & Resato presentation")}
            </a>
            <img
              src={services32}
              alt="Service Illustration"
              className="w-full rounded-lg shadow-md mt-6"
            />
          </div>

          {/* Right Image */}
          <div className="mt-8 md:mt-0 md:w-1/2">
            <img
              src={services31}
              alt="Service Illustration"
              className="w-full rounded-lg shadow-md"
            />
          </div>
        </div>
        <div className="max-w-containerSm md:max-w-container mx-auto md:flex md:items-start md:justify-between gap-10">
          <div>
            <p className="text-[22px] md:text-[44px] font-bold text-[#141615] font-firstFont mt-10">
              {t("Commissioning, Inspection & Maintenance, Calibration")}
            </p>

            <p className="mt-5 text-[14px] md:text-[20px] text-[#41444B]">
              {t(
                "Maintenance and service are needed to maintain the quality of your execution and extend the lifetime of your systems. For high pressure test stands, gas boosters, pumps, and other products, constant physical stress on components creates wear and eventually failure. To prevent this failure and to reduce downtime of your processes, we provide a range of options to you from regular service visits and calibration services to in-house support. Our Customer Care Experts will be able to advice you on a solution that brings out the best in your equipment, suited for your processes."
              )}
            </p>
            <p className="mt-5 text-[14px] md:text-[20px] text-[#41444B]">
              {t("In-house support")}
            </p>
            <p className="mt-5 text-[14px] md:text-[20px] text-[#41444B]">
              {t("Support on site")}
            </p>
          </div>
        </div>
        <div className="max-w-containerSm md:max-w-container mx-auto  md:flex md:items-start md:justify-between gap-10">
          <div>
            <p className="text-[22px] md:text-[44px] font-bold text-[#141615] font-firstFont mt-10">
              {t("Training")}
            </p>

            <p className="mt-5 text-[14px] md:text-[20px] text-[#41444B]">
              {t(
                "We offer several training modules to fully prepare you for your high-pressure system. With our investment in the training modules, we optimally prepare you to operate and maintain your high-pressure solution!"
              )}
            </p>
            <p className="mt-5 text-[14px] md:text-[20px] text-[#41444B]">
              {t("Operator training")}
            </p>
            <p className="mt-5 text-[14px] md:text-[20px] text-[#41444B]">
              {t("Maintenance training")}
            </p>
          </div>
        </div>
        <div className="max-w-containerSm md:max-w-container mx-auto md:flex md:items-start md:justify-between gap-10">
          <div>
            <p className="text-[22px] md:text-[44px] font-bold text-[#141615] font-firstFont mt-10">
              {t("Spares and rentals")}
            </p>

            <p className="mt-5 text-[14px] md:text-[20px] text-[#41444B]">
              {t(
                "In case you need spares and or consumables, you are able to contact our team. Our team is able to quote the items required. Also we have a range of rental machines which we are able to rent out in case you need high pressure machinery for a shorter period of time. Contact our team in case you need spares or rental machines."
              )}
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default Resato;
